import React from 'react';
import { motion } from 'motion/react';
import MarkdownContent from './MarkdownContent';
import { ItemLink } from '../utils/itemLinks';

/**
 * SearchSummary - "AI Summary" callout shown above search results.
 *
 * Shared across Gallery/Entities/Places (COL-68) — was a copy-pasted,
 * inline-styled motion.div on each page that had already drifted (Gallery
 * rendered markdown with item links, Entities/Places rendered plain text).
 */
export default function SearchSummary({ answer, items, onItemClick }) {
  if (!answer) return null;
  return (
    <motion.div
      initial={{ opacity: 0, y: -10 }}
      animate={{ opacity: 1, y: 0 }}
      className="search-summary"
    >
      <div className="search-summary-label">AI Summary</div>
      <MarkdownContent
        style={{ color: 'var(--text-secondary)' }}
        components={{
          a: (props) => <ItemLink {...props} onItemClick={onItemClick} items={items} />,
        }}
      >
        {answer}
      </MarkdownContent>
    </motion.div>
  );
}
